/**
 * Aprende más popup
 * --------------------------------------------------------------
 * Lazy-loaded modal triggered by `.ver-mas` buttons on product cards.
 * Fetches the marketing page referenced in `data-url` and injects its
 * main content into a native <dialog> element.
 *
 * Created on first click; reused thereafter. Uses event delegation so
 * dynamically inserted cards (filters, AJAX paginators) also work.
 */
(function () {
  'use strict';

  var dialog = null;
  var contentEl = null;
  var bodyEl = null;
  var cache = new Map();
  var currentRequestId = 0;

  function ensureDialog() {
    if (dialog) return;

    var style = document.createElement('style');
    style.textContent =
      '.aprende-mas-dialog{' +
        'padding:0;border:none;border-radius:10px;width:90%;max-width:800px;' +
        'max-height:90vh;background:#fff;color:inherit;overflow:hidden;' +
        'box-shadow:0 4px 15px rgba(0,0,0,.2);' +
      '}' +
      '.aprende-mas-dialog::backdrop{background:rgba(0,0,0,.5);}' +
      '.aprende-mas-dialog[open]{animation:aprende-mas-in .18s ease-out;}' +
      '.aprende-mas-dialog[open]::backdrop{animation:aprende-mas-fade .18s ease-out;}' +
      '@keyframes aprende-mas-in{from{opacity:0;transform:scale(.96);}to{opacity:1;transform:scale(1);}}' +
      '@keyframes aprende-mas-fade{from{opacity:0;}to{opacity:1;}}' +
      '.aprende-mas-dialog__body{max-height:90vh;overflow-y:auto;padding:48px 20px 20px;}' +
      '.aprende-mas-dialog__close{' +
        'position:absolute;top:8px;right:12px;width:36px;height:36px;' +
        'background:transparent;border:none;font-size:26px;line-height:1;' +
        'cursor:pointer;color:inherit;z-index:1;border-radius:50%;' +
      '}' +
      '.aprende-mas-dialog__close:hover{background:rgba(0,0,0,.06);}' +
      '.aprende-mas-dialog__status{padding:40px 20px;text-align:center;color:#666;}';
    document.head.appendChild(style);

    dialog = document.createElement('dialog');
    dialog.className = 'aprende-mas-dialog';
    dialog.setAttribute('aria-label', 'Aprende más');
    dialog.innerHTML =
      '<button type="button" class="aprende-mas-dialog__close" aria-label="Cerrar">&times;</button>' +
      '<div class="aprende-mas-dialog__body"><div class="aprende-mas-dialog__content"></div></div>';

    document.body.appendChild(dialog);
    contentEl = dialog.querySelector('.aprende-mas-dialog__content');
    bodyEl = dialog.querySelector('.aprende-mas-dialog__body');

    dialog.querySelector('.aprende-mas-dialog__close').addEventListener('click', function () {
      dialog.close();
    });

    // Click on backdrop (outside dialog content) closes
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    // Reset scroll and lock body scroll while open
    dialog.addEventListener('close', function () {
      document.body.style.overflow = '';
      if (bodyEl) bodyEl.scrollTop = 0;
    });
  }

  function showStatus(message) {
    contentEl.innerHTML = '<div class="aprende-mas-dialog__status">' + message + '</div>';
  }

  async function openPopup(url) {
    ensureDialog();
    var requestId = ++currentRequestId;

    if (!dialog.open) {
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    }

    if (cache.has(url)) {
      contentEl.innerHTML = cache.get(url);
      bodyEl.scrollTop = 0;
      return;
    }

    showStatus('Cargando...');

    try {
      var response = await fetch(url);
      if (requestId !== currentRequestId) return;
      if (!response.ok) throw new Error('HTTP ' + response.status);

      var html = await response.text();
      if (requestId !== currentRequestId) return;

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var mainContent = doc.querySelector('main') || doc.querySelector('.page-width') || doc.body;
      var injected = mainContent.innerHTML;

      contentEl.innerHTML = injected;
      bodyEl.scrollTop = 0;
      cache.set(url, injected);
    } catch (err) {
      if (requestId !== currentRequestId) return;
      console.error('Aprende más: error cargando la página', err);
      showStatus('Error al cargar el contenido.');
    }
  }

  // Event delegation: works for cards loaded dynamically by filters/AJAX
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.ver-mas');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    var url = link.getAttribute('data-url');
    if (url) openPopup(url);
  });
})();